const CURRENCY_SYMBOL_MAP = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  INR: "₹",
  AED: "AED ",
  CAD: "C$",
  AUD: "A$",
  NZD: "NZ$",
  SGD: "S$",
  JPY: "¥",
  CNY: "¥",
  CHF: "CHF ",
};

const toNumber = (value) => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === "string") {
    const cleaned = value.replace(/,/g, "").trim();
    const parsed = Number(cleaned);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export const getCurrencySymbol = (currencyCode) => {
  const normalizedCode = (currencyCode || "USD").toUpperCase();
  return CURRENCY_SYMBOL_MAP[normalizedCode] || `${normalizedCode} `;
};

export const formatCurrencyAmount = (
  amount,
  currencyCode,
  options = {}
) => {
  const { minimumFractionDigits = 2, maximumFractionDigits = 2 } = options;
  const symbol = getCurrencySymbol(currencyCode);
  const numericAmount = toNumber(amount);

  if (numericAmount === null) {
    return `${symbol}${amount ?? ""}`;
  }

  const formattedNumber = numericAmount.toLocaleString("en-US", {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return `${symbol}${formattedNumber}`;
};
